






















































































































































import { Component, Vue } from 'vue-property-decorator'
import moment from 'moment'
import { ICipher } from '@/types/cipher/types'
import { statusMap } from '@/constant/cipherConstant'
import { apiAddCipher, apiSearchCipher, apiUpdateCipher } from '@/api/cipher'
import Nav from '@/components/navbar/index.vue'
import { getUser } from "@/api/user";

@Component({
  name: 'Cipher',
  components: {
    Nav
  }
})
export default class extends Vue {
  private searchName = ''
  private listLoading = false
  private cipherList: ICipher[] = []

  private redirectUrlVisible = false
  private redirectUrl = ''

  private isShowDialog = false
  private submitLoading = false
  private isChangePassword = false
  private isAdd = true
  private dialogTitle = '添加密码'
  private statusMap = statusMap
  private oldCipher: ICipher | undefined
  private cipher: ICipher = {
    id: 0,
    createTime: 0,
    name: '',
    userName: '',
    password: '',
    email: '',
    phoneNumber: '',
    link: '',
    updateDateTime: '',
    status: 1
  }

  private descCreateTime (createTime: number) {
    return moment(createTime).format('YYYY-MM-DD HH:mm:ss')
  }

  private descStatus (status: number) {
    return status === 1 ? '正常' : '删除'
  }
  mounted () {
      this.searchByName()
  }

  private async searchByName () {
    this.listLoading = true
    const param = {
      name: this.searchName
    }
    const result = await apiSearchCipher(param)
    if (result.status) {
      this.cipherList = []
      for (const c of result.data) {
        const cipher: ICipher = {
          id: c.id,
          createTime: c.createTime,
          name: c.name,
          userName: c.userName,
          password: c.password,
          email: c.email,
          phoneNumber: c.phoneNumber,
          link: c.link,
          updateDateTime: moment(c.updateTime).format('YYYY-MM-DD HH:mm:ss'),
          status: c.status
        }
        this.cipherList.push(cipher)
      }
    }
    this.listLoading = false
  }

  private showDialog (isAdd: boolean, c?: ICipher) {
    this.isShowDialog = true
    this.isAdd = isAdd
    if (this.isAdd) {
      this.dialogTitle = '添加网站密码'
    } else {
      if (c !== undefined) {
        this.cipher = c
        // 深拷贝，不能拷贝function
        this.oldCipher = JSON.parse(JSON.stringify(c))
      }
      this.isChangePassword = false
      this.dialogTitle = '修改网站密码'
    }
  }

  private handleRedirect (cipher: ICipher) {
    this.redirectUrlVisible = true
    this.redirectUrl = cipher.link
  }

  private async submit () {
    this.submitLoading = true
    if (this.isAdd) {
      const param = {
        name: this.cipher.name,
        userName: this.cipher.userName !== '' ? this.cipher.userName : undefined,
        email: this.cipher.email !== '' ? this.cipher.email : undefined,
        phoneNumber: this.cipher.phoneNumber !== '' ? this.cipher.phoneNumber : undefined,
        link: this.cipher.link
      }
      const result = await apiAddCipher(param)
      if (result.status) {
        const c = result.data
        const cipher: ICipher = {
          id: c.id,
          createTime: c.createTime,
          name: c.name,
          userName: c.userName,
          password: c.password,
          email: c.email,
          phoneNumber: c.phoneNumber,
          link: c.link,
          updateDateTime: moment(c.updateTime).format('YYYY-MM-DD HH:mm:ss'),
          status: c.status
        }
        this.cipherList.push(cipher)
        this.$message.success('添加成功')
      }
    } else {
      if (this.oldCipher === undefined ||
        (this.oldCipher.name === this.cipher.name &&
          this.oldCipher.userName === this.cipher.userName &&
          !this.isChangePassword &&
          this.oldCipher.email === this.cipher.email &&
          this.oldCipher.phoneNumber === this.cipher.phoneNumber &&
          this.oldCipher.link === this.cipher.link &&
          this.oldCipher.status === this.cipher.status)) {
        this.$message.warning('请修改内容')
        this.isShowDialog = false
        this.submitLoading = false
        return
      }

      const param = {
        id: this.cipher.id,
        name: this.cipher.name !== this.oldCipher.name ? this.cipher.name : undefined,
        userName: this.cipher.userName !== this.oldCipher.userName ? this.cipher.userName : undefined,
        password: this.isChangePassword ? '1' : undefined,
        email: this.cipher.email !== this.oldCipher.email ? this.cipher.email : undefined,
        phoneNumber: this.cipher.phoneNumber !== this.oldCipher.phoneNumber ? this.cipher.phoneNumber : undefined,
        link: this.cipher.link !== this.oldCipher.link ? this.cipher.link : undefined,
        status: this.cipher.status !== this.oldCipher.status ? this.cipher.status : undefined
      }
      const result = await apiUpdateCipher(param)
      if (result.status) {
        const newCipherList: ICipher[] = []
        for (const i in this.cipherList) {
          if (this.cipherList[i].id !== this.cipher.id) {
            newCipherList.push(this.cipherList[i])
          }
        }

        const c = result.data
        const cipher: ICipher = {
          id: c.id,
          createTime: c.createTime,
          name: c.name,
          userName: c.userName,
          password: c.password,
          email: c.email,
          phoneNumber: c.phoneNumber,
          link: c.link,
          updateDateTime: moment(c.updateTime).format('YYYY-MM-DD HH:mm:ss'),
          status: c.status
        }
        newCipherList.push(cipher)
        this.cipherList = newCipherList

        this.$message.success('修改成功')
      }
    }
    this.isShowDialog = false
    this.submitLoading = false
  }
}
